import { useState, useCallback } from 'react';

export default function useErrors() {
    const [, updateErrorState] = useState();

    const throwReactError = useCallback((err) => {
        // in order to make React aware of the error thrown outside of the rendering lifecycle
        // we trigger an error in a state update.
        // This will make sure the errors are intercepted by the closest error boundary.
        updateErrorState(() => { throw err; });
    }, []);

    return { throwReactError };
}
